import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './dialog';
import { SHORTCUT_DESCRIPTIONS } from '../../hooks/useKeyboardShortcuts';
import { useGameStore } from '../../store/gameStore';
import { Keyboard } from 'lucide-react';

/**
 * KeyboardShortcutsModal - Modal displaying all available keyboard shortcuts
 * 
 * @param {boolean} open - Whether the modal is open
 * @param {function} onClose - Called when modal should close
 */
export const KeyboardShortcutsModal = ({ open, onClose }) => {
  const selectedTheme = useGameStore((state) => state.selectedTheme);

  const themeAccent = {
    noir: '#DC143C',
    '90s_nyc': '#FF6B35',
    miami_vice: '#FF1493',
  }[selectedTheme || 'noir'];

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="max-w-md bg-slate-900 border-2"
        style={{ borderColor: themeAccent }}
      >
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-white flex items-center gap-2">
            <Keyboard className="w-5 h-5" style={{ color: themeAccent }} />
            Keyboard Shortcuts
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-1 mt-4">
          {SHORTCUT_DESCRIPTIONS.map((shortcut) => (
            <div
              key={shortcut.key}
              className="flex items-center justify-between py-2 border-b border-slate-700/50 last:border-0"
            >
              <span className="text-gray-300 text-sm">{shortcut.action}</span>
              <kbd 
                className="px-2 py-1 bg-slate-800 border border-slate-600 rounded text-sm font-mono text-white min-w-[40px] text-center"
                style={{ borderColor: `${themeAccent}30` }}
              >
                {shortcut.key}
              </kbd>
            </div>
          ))}
        </div>

        <div className="mt-4 pt-4 border-t border-slate-700">
          <p className="text-xs text-gray-500 text-center">
            Press <kbd className="px-1 py-0.5 bg-slate-800 border border-slate-600 rounded text-xs font-mono">?</kbd> anytime to show this menu
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default KeyboardShortcutsModal;
